'use client'

import { useStoreSeason } from '@/store'
import { Typo3Page } from '@/types'
import { memo, useLayoutEffect } from 'react'

interface PageSeasonProps {
  data: NonNullable<Typo3Page['appearance']>['layoutSeason']
}

/**
 * Pushes the current page's `appearance.layoutSeason` into the season store
 * so layout-level components (e.g. Header) can react to it.
 */
const PageSeason = ({ data }: PageSeasonProps) => {
  const setLayoutSeason = useStoreSeason.use.setLayoutSeason()

  useLayoutEffect(() => {
    setLayoutSeason(data)
  }, [data, setLayoutSeason])

  return null
}

export default memo(PageSeason)
